import React from 'react';
import PropTypes from 'prop-types';

const X01Icon = ({color = 'currentColor', ...props}) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.1673 0.833255L0.833984 14.1666M14.1673 14.1666L0.833985 0.833252"
      stroke="#5C6EBB"
      strokeWidth="1.66667"
      strokeLinecap="round"
    />
  </svg>

);

X01Icon.propTypes = {
  color: PropTypes.string,
};

export default X01Icon;
